// src/pages/usa/puertorico/Lajas.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";  
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";


import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Jayuya ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Lajas() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Lajas, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Lajas, Puerto Rico</h2>

            <p>
              Lajas is a charming town located in the southwestern region of Puerto Rico, known 
              for its stunning natural beauty and vibrant culture. Nestled between the mountains 
              and the sparkling Caribbean Sea, Lajas offers a unique blend of outdoor adventures 
              and cultural experiences. Whether you're exploring the bioluminescent bay, hiking 
              through verdant trails, or enjoying local cuisine, Lajas is a must‑visit destination 
              for travelers seeking both relaxation and excitement.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
             <p>
  To reach Lajas, you can drive from San Juan, which takes approximately 2.5 to 3 hours.
  The route takes you through scenic landscapes and small towns, making the journey part
  of the adventure. You can also fly into Aguadilla’s Rafael Hernández Airport (BQN),
  which is about 1 hour and 10 minutes from Lajas — a convenient option if you're coming
  from the mainland. Another option is flying into Mercedita Airport in Ponce, located
  about 30 minutes from Lajas. If you prefer public transportation, you can take a bus
  from San Juan to Ponce and then continue by taxi or local transportation to Lajas.
</p>

            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>La Parguera:</strong> La Parguera is a picturesque fishing village known for 
                  its bioluminescent bay, where the water glows at night due to microscopic organisms. 
                  It’s a magical experience to kayak or take a boat tour through the bay after sunset. 
                  During the day, you can explore the nearby mangroves, snorkel in the clear waters, or 
                  simply relax by the shore.  During the night tour, you can also see the stars reflected in 
                  the water, creating a truly enchanting atmosphere.  The night life in La Parguera is also 
                  vibrant, with local bars and restaurants offering fresh seafood and live music, making it 
                  a great spot to unwind after a day of exploring.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.973565036441933, -67.04840274436863"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Bioluminescent Bay:</strong> The Bioluminescent Bay in La Parguera is one of the 
                  most famous attractions in Lajas. The bay’s glowing waters are a result of bioluminescent 
                  organisms that light up when disturbed. Taking a nighttime kayak tour through the bay is 
                  an unforgettable experience, allowing you to witness this natural phenomenon up close. 
                  The serene environment and the magical glow create a surreal atmosphere that is perfect for
                   nature lovers and photographers alike.  The tours are typically led by knowledgeable guides 
                   who share insights about the ecosystem and the science behind the bioluminescence, making 
                   it both an educational and awe‑inspiring experience.  The bay is also a great spot for 
                   stargazing, as the lack of light pollution allows for clear views of the night sky. 
                   Special note: the bioluminescence is best seen on moonless nights, so planning your visit
                    around the lunar cycle can enhance your experience.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.971824198737913, -67.0453245977531"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Kayak 
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=17.973269143362142, -67.04828489074612"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Boat Tours
                  </a>
                </div>
              </li>

              
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

<ul>

  <li>
    <div className="place-block">
      <strong>Playa Rosada:</strong>
      A unique swimming area with a floating platform and calm, clear water. Great for relaxing,
      taking photos, and enjoying a quiet beach day away from the crowds. 
      Special note: In my last visit to Puerto Rico, June 2026, the area of Playa Rosada was closed.  The
      area was destroyed and looks like they are rebuilding it.  I will update this page when
       I have more information about the reopening of this area.
      
      <br />
      <a
        href="https://www.google.com/maps?q=17.972146151111346, -67.03237794746178"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Cayo Caracoles:</strong>
      One of the most popular cays in the area with shallow turquoise water perfect for floating,
      swimming, and relaxing. Accessible by boat or water taxi.  There are some boats trip to this cay from 
      the main dock in La Parguera, but you can also rent a kayak or paddleboard to explore it on your own.  
      The cay is surrounded by coral reefs, making it a great spot for snorkeling and spotting marine life. 
       It’s a fantastic place to spend a day soaking up the sun and enjoying the crystal-clear waters of 
       the Caribbean.
      <a
        href="https://www.google.com/maps?q=17.96123097327213, -67.03724592485356"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Cayo Enrique:</strong>
      A quieter cay with clear water and great snorkeling. Ideal for a peaceful beach day and
      exploring the surrounding mangroves.
      <br />
      <a
        href="https://www.google.com/maps?q=17.957014572819336, -67.042974628229"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>


</ul>


            <h3>🛏️ Places to Stay in Lajas</h3>

<p>
  Lajas has several great places to stay, especially around the La Parguera area where
  most restaurants, boat tours, and coastal activities are located. These options are
  well‑rated as of November 2026 — always double‑check Booking.com or Expedia for the
  latest reviews and availability.
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>Parguera Plaza Hotel:</strong>
      A modern, centrally located hotel right by the waterfront area. Guests like the
      clean rooms, pool, and easy access to restaurants and boat tours.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Parador Villa Parguera:</strong>
      One of the most popular stays in Lajas, with a pool, ocean views, and a relaxing
      atmosphere. Great location for walking around the area.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>La Jamaca:</strong>
      A colorful, laid‑back guesthouse with hammocks, a pool, and a tropical vibe.
      Known for friendly staff and a peaceful setting just outside the busy waterfront.
      <em> (Listed on Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Posada del Paraíso:</strong>
      A small, cozy guesthouse with clean rooms and a quiet atmosphere. Good option
      for travelers looking for something simple and affordable.
      <em> (Listed on Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Ocean View Rentals – La Parguera:</strong>
      Private apartments and small villas with ocean views and kitchenettes. Great for
      longer stays or families.
      <em> (Some units not listed on Booking/Expedia)</em>
    </div>
  </li>

</ul>


            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed in Jayuya. Be sure to set the quality to
              1080p or higher. Hope you enjoy them!
            </p>

            <p>
              <a
                href="https://youtu.be/neVJE5Kpzi8?si=VdKeq6RoAyip-S-i"
                target="_blank"
                rel="noopener noreferrer"
              >
                La Parguera
              </a>
            </p>

          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/f_AyQ3s1dv0?si=YOjzEzLEU1m31yMp"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/lajas/parguera2.jpg"
                alt="La Parguera"
              />
            </a>

            <img
              src="/images/usa/puertorico/lajas/parguera.jpg"
              alt="La Parguera"
            />
            <img
              src="/images/usa/puertorico/lajas/parguera3.jpg"
              alt="La Parguera"
            />
            <img
              src="/images/usa/puertorico/lajas/parguera5.jpg"
              alt="La Parguera"
            />
            <img
              src="/images/usa/puertorico/lajas/cayoview.jpg"
              alt="Cayos"
            />
            <img
              src="/images/usa/puertorico/lajas/cayos2.jpg"
              alt="Cayos"
            />
            <img
              src="/images/usa/puertorico/lajas/cayos.jpg"
              alt="Cayos"
            />
            <img
              src="/images/usa/puertorico/lajas/cayos3.jpg"
              alt="Cayos"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
